import * as React from "react";
import { AlertTriangle, X } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

interface AlertWarningProps {
  show: boolean;
  onDismiss?: () => void;
  title: string;
  description: string;
  variant?: "destructive" | "default" | "warning";
  className?: string;
  icon?: React.ReactNode;
}

export function AlertWarning({
  show,
  onDismiss,
  title,
  description,
  variant = "destructive",
  className,
  icon = <AlertTriangle className="h-4 w-4" />,
}: AlertWarningProps) {
  if (!show) return null;

  return (
    <Alert 
      variant={variant} 
      className={cn("mb-6", onDismiss && "pr-12", className)}
    >
      {icon}
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="absolute top-4 right-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Cerrar</span>
        </button>
      )}
    </Alert>
  );
}
